// src/components/BookSection.jsx
import React, { useRef } from 'react';
import './BookSection.css';

const books = [
  {
    id: 1,
    cover: '/assets/Images/Home/BookSection/crown-of-midnight.webp',
    link: 'https://www.goodreads.com/book/show/17670709-crown-of-midnight',
    title: 'Crown of Midnight',
    subtitle: '(Throne of Glass)',
    author: 'Sarah J. Maas',
    genre: 'Young Adult / Fantasy',
    date: 'Nov 11, 2018',
    status: 'Read'
  },
  {
    id: 2,
    cover: '/assets/Images/Home/BookSection/war-of-the-worlds.webp',
    link: 'https://www.goodreads.com/book/show/8909.The_War_of_the_Worlds',
    title: 'The War of the Worlds',
    author: 'H.G. Wells',
    genre: 'Sci-Fi',
    date: 'Jul 25, 2018',
    status: 'Read'
  },
  {
    id: 3,
    cover: '/assets/Images/Home/BookSection/daphne.webp',
    link: 'https://www.goodreads.com/book/show/59763901-daphne',
    title: 'Daphne',
    author: 'Josh Malerman',
    genre: 'Horror',
    date: 'Mar 19, 2024',
    status: 'Read'
  },
  {
    id: 4,
    cover: '/assets/Images/Home/BookSection/dance-of-thieves.webp',
    link: 'https://www.goodreads.com/book/show/35796008-dance-of-thieves',
    title: 'Dance of Thieves',
    author: 'Mary E. Pearson',
    genre: 'Young Adult / Fantasy',
    status: 'Currently Reading'
  }
];

const BookSection = () => {
  return (
    <section className="section-title">
      <h2 className="section-title">Perhaps, interesting facts?</h2>
      <p className="section-subtitle">Some of my favs.</p>
      <div className="book-grid">
        {books.map(book => (
          <BookCard key={book.id} book={book} />
        ))}
      </div>
    </section>
  );
};

function BookCard({ book }) {
  const imgRef = useRef(null);

  const handleMouseMove = e => {
    const el = imgRef.current;
    const rect = el.getBoundingClientRect();
    const ratioX = (e.clientX - rect.left) / rect.width;
    const ratioY = (e.clientY - rect.top) / rect.height;

    // Enhanced tilt effect
    const tiltX = (ratioY - 0.2) * -5;  // ±12.5deg around X-axis
    const tiltY = (ratioX - 0.2) * 5;   // ±12.5deg around Y-axis
    el.style.transform = `rotateX(${tiltX}deg) rotateY(${tiltY}deg)`;

    // Stronger shine movement: range -200% to +200%
    const shinePos = ratioX * 50 - 200;
    el.style.setProperty('--shine', `${shinePos}%`);
  };

  const handleMouseLeave = () => {
    const el = imgRef.current;
    el.style.transform = 'rotateX(0) rotateY(0)';
    el.style.setProperty('--shine', '-200%');
  };

  return (
    <div className="book-card">
      <a
        href={book.link}
        target="_blank"
        rel="noopener noreferrer"
        className="book-link"
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        <div className="book-image" ref={imgRef}>
          <img src={book.cover} alt={book.title} className="book-cover" />
        </div>
      </a>
      <div className="book-info">
        <h3 className="book-title">
          {book.title}
          {book.subtitle && (
            <span className="book-subtitle">{book.subtitle}</span>
          )}
        </h3>
        <p className="book-author">{book.author}</p>
        <p className="book-genre">{book.genre}</p>
        <p className="book-date">
          {book.status === 'Currently Reading'
            ? book.status
            : `Read: ${book.date}`}
        </p>
      </div>
    </div>
  );
}

export default BookSection;
